import EcommerceSolutionsOffers from "./EcommerceSolutionsOffers";

const EcommerceSolutions = () => {
  return (
    <section className="solution-item-page">
      <EcommerceSolutionsOffers />
    </section>
  );
};

export default EcommerceSolutions;
